import moment from "moment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CertificationService } from "../../../../certification/services/certification-service";
import { StateManagementService } from "../../../../providers/state-management/state-management.service";
import { InputObservableValue } from "./input-observable";

export interface BenefitPeriodResponse {
  benefitPeriod: number;
  startDate: string;
  endDate: string;
  isCurrentBenefitPeriod: number;
}

export function currentAndUpcomingBenefitPeriods(
  certificationService: CertificationService,
  stateManagementService: StateManagementService
): Observable<InputObservableValue> {
  const patChartId = stateManagementService.getChartId();
  return certificationService.getCurrentAndSoonBenefits(patChartId, 30).pipe(
    map((response: BenefitPeriodResponse[]) => {
      return {
        options: response.map((item) => {
          const startDate = moment(item.startDate).format("MM/DD/YYYY");
          const endDate = moment(item.endDate).format("MM/DD/YYYY");
          return {
            display: `Period ${item.benefitPeriod} — ${startDate} to ${endDate}`,
            value: `${item.benefitPeriod}`,
          };
        }),
        hideOther: true,
      };
    })
  );
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/select-input/current-and-upcoming-benefit-periods.ts